import { render, staticRenderFns } from "./DocumentDataTable.vue?vue&type=template&id=fd5c5dc8&scoped=true"
import script from "./DocumentDataTable.vue?vue&type=script&lang=js"
export * from "./DocumentDataTable.vue?vue&type=script&lang=js"
import style0 from "./DocumentDataTable.vue?vue&type=style&index=0&id=fd5c5dc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5c5dc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VAlert,VCheckbox,VDataTable,VIcon,VLayout,VProgressLinear})
